module.exports = __webpack_public_path__ + "assets/events_travel_blue.f77d05df.svg";